import { render } from "./FilterProvince.vue?vue&type=template&id=0c34fefe"
import script from "./FilterProvince.vue?vue&type=script&lang=js"
export * from "./FilterProvince.vue?vue&type=script&lang=js"
script.render = render

export default script